import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { IDiningOptionEnum } from "@/api/interfaces/configurationLayouts";
import Loader from "@/base/components/Global/Loader";
import { NavigationPath } from "@/constants/navigation";
import { useAppDispatch, useAppSelector } from "@/store";
import {
  initializeDiningCartWithMigration,
  resetShoppingCart,
} from "@/store/shoppingCart";
import {
  getTheatreResource,
  resetTheatreResource,
} from "@/store/theatreResource";
import { selectUserId } from "@/store/user";

const QrLandingPage = () => {
  const navigate = useNavigate();
  const { qrCode } = useParams();

  const userId = useAppSelector(selectUserId);
  const dispatch = useAppDispatch();
  const isInitializedRef = useRef(false);

  useEffect(() => {
    if (isInitializedRef.current) {
      return;
    }

    if (!qrCode) {
      void navigate(`${NavigationPath.Home}?source=qr`);
      return;
    }

    isInitializedRef.current = true;

    // TODO: important - we should also send a clearance request. So that carts are not hoarded.
    // We also need to have the navbar button state reflect that the cart is cleared.
    dispatch(resetShoppingCart());
    dispatch(resetTheatreResource());

    dispatch(getTheatreResource({ barcodeWithoutChecksum: qrCode }))
      .unwrap()
      .then((resource) =>
        dispatch(
          initializeDiningCartWithMigration({
            theatreResourceId: resource.ID,
            dttmRequestedDelivery: null,
            diningOptionId: IDiningOptionEnum.DINE_IN,
            customerPersonId: userId,
          }),
        ).unwrap(),
      )
      .then(() => {
        void navigate(`${NavigationPath.Home}?source=qr`);
      })
      .catch((error: unknown) => {
        if (
          !(error && typeof error === "object" && "name" in error) ||
          error.name !== "ConditionError"
        ) {
          console.error(`Could not find QR code "${qrCode}"`, error);
        }

        void navigate(`${NavigationPath.Home}?source=qr`);
      });
  }, [qrCode]);

  return <Loader isFullScreen />;
};

export default QrLandingPage;
